import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import dismissCartConvertToast from '../actions/dismissCartConvertToast';
import SuccessToast from './SuccessToast';


const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators({ dismissCartConvertToast }, dispatch);
  return { ...actions, dispatch };
};

const mapStateToProps = (state) => {
  const options = state.estimateBuilder.uiState.toastOptions;
  return { options };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuccessToast);
